import { render, staticRenderFns } from "./ItemImage.vue?vue&type=template&id=7c20061d&"
import script from "./ItemImage.vue?vue&type=script&lang=ts&"
export * from "./ItemImage.vue?vue&type=script&lang=ts&"
import style0 from "./ItemImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports